import styled from '@emotion/styled';
import { TextInput } from '@hotjar/hotsauce';
import { isEmpty, trim } from 'lodash-es';
import type { BasicListOption } from '../../GenericBloc/GenericLargeListFilter/GenericLargeListType';
import type { RadioTextFilterValueType } from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { RadioTextFilterOperation } from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { COLUMN_TWO_WIDTH } from './ClickedFilterConstant';
import { GenericFilterSelect } from '../../GenericBloc/GenericFilterSelect/GenericFilterSelect';
import type { InfoFooter } from '../../GenericBloc/GenericFilterSelect/GenericFilterSelectType';

const TextInputWrapper = styled.div`
  flex-grow: 1;
  max-width: 198px; // We force the size because inputText in error is taking too much otherwise
`;

const OperationWrapper = styled.div`
  min-width: ${COLUMN_TWO_WIDTH}px;
`;

interface RadioTextFilterSectionProps {
  value?: RadioTextFilterValueType;
  onChange: (newValue: RadioTextFilterValueType) => void;
  optionList: BasicListOption<RadioTextFilterOperation>[];
  placeholders?: Partial<Record<RadioTextFilterOperation, string>>;
  showValidationError: boolean;
  infoFooter?: InfoFooter;
  removeSpaceInInput?: boolean;
}

export const RadioTextFilterSection = ({
  value,
  onChange,
  optionList,
  placeholders,
  showValidationError,
  infoFooter,
  removeSpaceInInput,
}: RadioTextFilterSectionProps): JSX.Element => {
  return (
    <>
      <OperationWrapper>
        <GenericFilterSelect
          value={value?.operation}
          optionList={optionList}
          onChange={(newOperationValue) => {
            let newValue;
            if (
              newOperationValue === RadioTextFilterOperation.HAS_ANY_VALUE ||
              newOperationValue === RadioTextFilterOperation.IS_UNKNOWN
            ) {
              newValue = {
                operation: newOperationValue,
              };
            } else {
              newValue = {
                operation: newOperationValue,
                value: value && 'value' in value ? value.value : '',
              };
            }
            onChange(newValue);
          }}
          size="s"
          infoFooter={infoFooter}
        />
      </OperationWrapper>
      {value &&
        value.operation &&
        value.operation !== RadioTextFilterOperation.HAS_ANY_VALUE &&
        value.operation !== RadioTextFilterOperation.IS_UNKNOWN && (
          <TextInputWrapper>
            <TextInput
              size="s"
              value={value?.value}
              placeholder={placeholders ? placeholders[value.operation] : ''}
              isInvalid={showValidationError && isEmpty(trim(value?.value))}
              autoFocus
              name="sub-filter-text"
              onChange={(newStringValue) => {
                const text = newStringValue.target.value ?? '';
                const newValue = {
                  operation: value?.operation,
                  value: removeSpaceInInput === true ? text.replace(/\s/g, '') : text,
                };
                onChange(newValue);
              }}
            />
          </TextInputWrapper>
        )}
    </>
  );
};
